import { Filters as FiltersSchema } from "schemas/filters";

export const fetchQuery = ({ brandId, resource }) => ({
    url: `/api/v3.0/brand/${brandId}/filters/${resource}`,
    schema: FiltersSchema,
    options: {
        method: "GET",
    },
});
